import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getPersonSecurities } from '@dealstack/frontend/shared/dataExchange/services/securities';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';

export const useGetPersonSecurities = (issuerPersonId?: string, withHoldingTotals = false) => {
	return useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.SECURITY_PERSON_SECURITIES_PERSONID_POST, {
				personId: issuerPersonId || '',
			}),
			{
				withHoldingTotals,
			},
		],
		queryFn: ({ signal }) =>
			getPersonSecurities(
				formatUnicorn(API_PATHS.SECURITY_PERSON_SECURITIES_PERSONID_POST, {
					personId: issuerPersonId || '',
				}),
				{
					withHoldingTotals,
				},
				signal
			),
		placeholderData: keepPreviousData,
		enabled: !!issuerPersonId,
	});
};
